import React from "react";

import { OrderDto } from "services/orders/restModels";
import { formatDateTime } from "shared/lib/dateTime";
import { orderStatusLabel } from "shared/lib/orderLabels";
import { SectionCard } from "shared/ui";

import { Body, ChangedAt, Dot, Entry, List, Status } from "./styles";

export const OrderStatusTimeline = ({ order }: { order: OrderDto }) => {
    if (order.statusHistory.length === 0) return null;

    return (
        <SectionCard title="История заказа">
            <List>
                {order.statusHistory.map((change, index) => (
                    <Entry
                        key={`${change.status}-${change.changedAt}-${index}`}
                        $isLast={index === order.statusHistory.length - 1}
                    >
                        <Dot />
                        <Body>
                            <Status>{orderStatusLabel(change.status)}</Status>
                            <ChangedAt>{formatDateTime(change.changedAt)}</ChangedAt>
                        </Body>
                    </Entry>
                ))}
            </List>
        </SectionCard>
    );
};
